import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';
import { parseOptionalNumber } from '../score.utils';

export function generateScoreFormField(
  params: FormFieldGenerationParams<'score'>,
): PartialPropsOf<'score'> {
  let props: PartialPropsOf<'score'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  const defaultValue = parseOptionalNumber(params.inputData.column.defaultValue);
  if (defaultValue != null) {
    props = applyPropsPatch(props, {
      content: { options: { defaultValue } },
    });
  }

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { options: { readonly: true } } });
  }

  return props;
}
